module.exports = __webpack_public_path__ + "img/dy.2769e496.png";